export const CREATE_ENTITY_ROUTE_NAME = 'create';
export const EDIT_ENTITY_ROUTE_NAME = 'edit';
